import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config';

const SubscriptionRoute = () => {
    const { user, auth } = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const [isAllowed, setIsAllowed] = useState(true);

    useEffect(() => {
        const checkSubscription = async () => {
            if (!user) {
                setIsLoading(false);
                return;
            }
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/v2/venues/limits`);
                if (response.ok) {
                    // All registered users (free and paid) are allowed to access their venue dashboard
                    setIsAllowed(true);
                } else {
                    setIsAllowed(true);
                }
            } catch (error) {
                console.error('Failed to check subscription:', error);
                setIsAllowed(true);
            } finally {
                setIsLoading(false);
            }
        };

        checkSubscription();
    }, [user, auth]);

    if (!user) {
        return <Navigate to="/sign-in" replace />;
    }

    if (user.role === 'admin') {
        return <Outlet />;
    }

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!isAllowed) {
        return <Navigate to="/pricing" replace />;
    }

    return <Outlet />;
};

export default SubscriptionRoute;
